import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Card, Row, Col, Alert } from 'react-bootstrap';
import InputNumber from './InputNumber';
import CheckBoxInput from './CheckBoxInput';
import RadioInput from './RadioInput';
import formInputsTypes from 'constants/simulatorData/simulatorConstant';

const SimulatorMotor = ({
	currentFormValue,
	setCurrentFormValue,
	simulatorData,
	scrollToBottom,
}) => {
	const [dataForm, setDataForm] = useState(simulatorData);
	const tabInputs = [];
	console.log('currentFormValue', currentFormValue);
	// const makeid = (length) => {
	// 	let result = '';
	// 	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	// 	const charactersLength = characters.length;
	// 	let counter = 0;
	// 	while (counter < length) {
	// 		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	// 		counter += 1;
	// 	}
	// 	return result;
	// };

	const injectObject = (object, injectedObject, targetIndex, index = 0) => {
		let newObject = object;
		if (index === targetIndex) {
			newObject = {
				...object,
				...injectedObject,
			};
		} else if (object.nextStep) {
			newObject = {
				...object,
				nextStep: {
					...injectObject(object.nextStep, injectedObject, targetIndex, index + 1),
				},
			};
		}
		return newObject;
	};
	const upsertOrdered = (ordered = [], key, value, order) => {
		const idx = ordered.findIndex((x) => x.key === key);
		if (idx === -1) return [...ordered, { key, value, order }]; // first time -> append
		// update value but keep original order
		const next = [...ordered];
		next[idx] = { ...next[idx], value };
		return next;
	};
	const handleSave = (func, data, nextStep, value) => {
		func(nextStep);
		setCurrentFormValue((prev) => {
			const key = data.name; // ALWAYS store under step name
			const order = prev?.orders?.[key] ?? orderRef.current++; // keep first order

			const nextOrders = { ...(prev?.orders ?? {}), [key]: order };
			const nextOrdered = upsertOrdered(prev?.ordered ?? [], key, value, order);

			return {
				...prev,
				values: { ...(prev?.values ?? {}), [key]: value },
				orders: nextOrders,
				ordered: nextOrdered,
				complet: !nextStep,
				// optional: final summary based on ordered inputs
				productFinal: nextOrdered
					.map((x) => x.value)
					.filter(Boolean)
					.join('\n\n'),
			};
		});
	};
	const orderRef = useRef(0);

	const switchInputs = (data, func) => {
		if (!data?.type) return;

		switch (data.type) {
			case formInputsTypes.RADIO_INPUT:
			case formInputsTypes.SELECT_INPUT:
				tabInputs.push(
					<div key={data.id} className='mb-4'>
						<RadioInput
							data={data}
							currentFormValue={currentFormValue}
							handelChange={(nextStep, value) => {
								handleSave(func, data, nextStep, value);
							}}

							// handelChange={(nextStep, value) => {
							// 	func(nextStep);
							// 	setCurrentFormValue({
							// 		...currentFormValue,
							// 		[!nextStep ? 'productFinal' : data.name]: value,
							// 		complet: !nextStep || currentFormValue?.productFinal,
							// 	});
							// }}
						/>
					</div>,
				);
				break;

			case formInputsTypes.CHECKBOX_INPUT:
				tabInputs.push(
					<div key={data.id} className='mb-4'>
						<CheckBoxInput
							data={data}
							currentFormValue={currentFormValue}
							handelChange={(valObj) => {
								setCurrentFormValue((prev) => {
									const merged = { ...prev, ...valObj };

									const allItems = Object.entries(merged)
										.filter(
											([k, v]) => k.endsWith('_items') && Array.isArray(v),
										)
										.flatMap(([, v]) => v);

									// order by "order" so it follows click order
									allItems.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

									const mainText = allItems
										.map((i) => i.text)
										.filter(Boolean)
										.join('\n\n'); // ✅ blank line between selected services

									const mainPrice = allItems.reduce(
										(sum, i) => sum + (Number(i.price) || 0),
										0,
									);

									return {
										...merged,
										productFinal: mainText ? `${mainText}` : '',
										price: mainPrice,
									};
								});
							}}
						/>
					</div>,
				);
				break;

			case formInputsTypes.INPUT_NUMBER:
			case formInputsTypes.INPUT_TEXT:
				tabInputs.push(
					<div key={data.id} className='mb-4'>
						<InputNumber
							autoFocus={true}
							data={data}
							handelChange={(nextStep, value) => {
								handleSave(func, data, nextStep, value);
							}}
						/>
					</div>,
				);
				break;

			default:
				console.warn(`Unknown input type: ${data.type}`);
				console.log('********', formInputsTypes.RADIO_INPUT, data.type);

				break;
		}
	};

	const createElementsForm = (object, index = 0) => {
		if (!object) return;

		switchInputs(object, (data) => {
			if (
				object.type !== formInputsTypes.CHECKBOX_INPUT &&
				object.type !== formInputsTypes.NUMERIC
			) {
				scrollToBottom?.();
			}
			setDataForm(
				injectObject(
					dataForm,
					{
						nextStep: data ? { ...data, id: `${data?.id}` } : false,
					},
					index,
				),
			);
		});

		if (object.nextStep) {
			createElementsForm(object.nextStep, index + 1);
		}
	};

	createElementsForm(dataForm);

	return (
		<div className='row'>
			{tabInputs.length ? (
				tabInputs
			) : (
				<Alert variant='info' className='text-center mb-0'>
					Aucune donnée définie
				</Alert>
			)}
		</div>
	);
};

SimulatorMotor.propTypes = {
	currentFormValue: PropTypes.object.isRequired,
	setCurrentFormValue: PropTypes.func.isRequired,
	simulatorData: PropTypes.object,
	scrollToBottom: PropTypes.func,
};

SimulatorMotor.defaultProps = {
	simulatorData: {},
	scrollToBottom: () => {},
};

export default SimulatorMotor;
